
export const GET_CHAT = 'GET_CHAT';
export const GET_CHAT_SUCCESS = 'GET_CHAT_SUCCESS';
export const ADD_OUTGOING_MESSAGE = 'ADD_OUTGOING_MESSAGE';

